export default __webpack_public_path__ + "7ed0c5b406f098da36a9c03927969f03.png";